var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInstagram = function SvgInstagram(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#paint0_linear_24897_318)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#paint1_radial_24897_318)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#paint2_radial_24897_318)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#paint3_radial_24897_318)",
    fillOpacity: 0.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#paint4_radial_24897_318)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#paint5_radial_24897_318)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "instagram",
    fill: "#ffffff",
    d: "M20,10.16c3.2,0,3.58,0.01,4.85,0.07c0.76,0.01,1.51,0.15,2.23,0.41 c1.05,0.4,1.87,1.23,2.28,2.28c0.26,0.71,0.4,1.47,0.41,2.23c0.06,1.27,0.07,1.64,0.07,4.85s-0.01,3.58-0.07,4.85 c-0.01,0.76-0.15,1.51-0.41,2.23c-0.4,1.05-1.23,1.87-2.28,2.28c-0.71,0.26-1.47,0.4-2.23,0.41c-1.27,0.06-1.64,0.07-4.85,0.07 s-3.58-0.01-4.85-0.07c-0.76-0.01-1.51-0.15-2.23-0.41c-1.05-0.4-1.87-1.23-2.28-2.28c-0.26-0.71-0.4-1.47-0.41-2.23 c-0.06-1.27-0.07-1.64-0.07-4.85s0.01-3.58,0.07-4.85c0.01-0.76,0.15-1.51,0.41-2.23c0.4-1.05,1.23-1.87,2.28-2.28 c0.71-0.26,1.47-0.4,2.23-0.41C16.42,10.17,16.8,10.16,20,10.16 M20,8c-3.26,0-3.67,0.01-4.95,0.07c-1,0.02-1.98,0.21-2.91,0.56 c-1.61,0.62-2.89,1.9-3.51,3.51c-0.35,0.93-0.54,1.92-0.56,2.91C8.01,16.33,8,16.74,8,20s0.01,3.67,0.07,4.95 c0.02,1,0.21,1.98,0.56,2.91c0.62,1.61,1.9,2.89,3.51,3.51c0.93,0.35,1.92,0.54,2.91,0.56C16.33,31.99,16.74,32,20,32 s3.67-0.01,4.95-0.07c1-0.02,1.98-0.21,2.91-0.56c1.61-0.62,2.89-1.9,3.51-3.51c0.35-0.93,0.54-1.92,0.56-2.91 C31.99,23.67,32,23.26,32,20s-0.01-3.67-0.07-4.95c-0.02-1-0.21-1.98-0.56-2.91c-0.62-1.61-1.9-2.89-3.51-3.51 c-0.93-0.35-1.92-0.54-2.91-0.56C23.67,8.01,23.26,8,20,8z M20,13.84c-3.4,0-6.16,2.76-6.16,6.16s2.76,6.16,6.16,6.16 c3.4,0,6.16-2.76,6.16-6.16S23.4,13.84,20,13.84C20,13.84,20,13.84,20,13.84z M20,24c-2.21,0-4-1.79-4-4s1.79-4,4-4s4,1.79,4,4 S22.21,24,20,24z M26.41,12.15c-0.8,0-1.44,0.64-1.44,1.44c0,0.8,0.64,1.44,1.44,1.44c0.8,0,1.44-0.64,1.44-1.44 S27.2,12.15,26.41,12.15L26.41,12.15z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24897_318",
    x1: 20.0414,
    y1: 10.766,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE02B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.256159,
    stopColor: "#FC2278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465895,
    stopColor: "#FF2160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5234"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_24897_318",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.12836 1.24224) rotate(64.7828) scale(15.7448 39.4586)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7837F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277606,
    stopColor: "#7837F9",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7837F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_24897_318",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.68944 39.1718) rotate(79.1145) scale(17.5413 27.8872)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD702",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_24897_318",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.8282 35.9834) rotate(-159.55) scale(7.82214 11.311)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D300C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D300C5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_24897_318",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6812 2.89855) rotate(165.426) scale(25.6707 14.3208)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D300C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D300C5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_24897_318",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-4.13929e-07 16.4803) rotate(-17.1428) scale(17.4199 9.07047)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D300C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D300C5",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInstagram);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/instagram.62de09549524e6b2080d2a3266ef44f0.svg";